.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 140px;
  text-align: center;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 20px;
}

.container .icon {
  background: #6c757d;
  padding: 14px;
  font-size: 40px;
  border-radius: 5px;
  color: white;
  margin-bottom: 20px;
}

h2 {
  font-weight: 600;
  margin-bottom: 16px;
  color: #333;
}

p {
  margin-bottom: 12px;
  color: var(--body-text);
  line-height: 1.5;
}

.refreshButton {
  margin-top: 24px;
}
